module.exports = __webpack_public_path__ + "static/media/order-header-bg.7467c9e3.png";